export default "__VITE_ASSET__BzVOjjRV__"